<script lang="ts">
    import { _ } from 'svelte-i18n';
    import src from './svg/lock_open_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    import IconPending from './IconPending.svelte';
    export let scale: number = 1;
    export let disabled: boolean = false;
    export let title: string | null = null;

    let defaultTitle = $_('Lock route');
</script>

{#if disabled}
    <IconPending spin={true} {scale} />
{:else}
    <TemplateIcon
        {src}
        {scale}
        hover={title || defaultTitle}
        alt={title || defaultTitle}
        on:click
    />
{/if}
